import * as React from "react";

import { cn } from "./utils";

const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<"textarea">>(
  ({ className, onFocus, ...props }, ref) => {
    const handleFocus = (e: React.FocusEvent<HTMLTextAreaElement>) => {
      setTimeout(() => {
        e.target.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 300);
      onFocus?.(e);
    };

    return (
      <textarea
        ref={ref}
        onFocus={handleFocus}
        data-slot="textarea"
        className={cn(
          // Base styles
          "flex w-full min-h-16 field-sizing-content bg-surface-L0 border border-border-L2 rounded-lg p-2 text-base text-content-primary-bold leading-normal tracking-[0.07px] outline-none transition-[color,box-shadow,border-color]",
          // Placeholder
          "placeholder:text-content-primary-subtle",
          // Focus state
          "focus-visible:border-border-focus focus-visible:ring-[1px] focus-visible:ring-border-focus/50",
          // Error state
          "aria-invalid:border-border-negative-bold aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40",
          // Disabled state
          "disabled:cursor-not-allowed disabled:opacity-50",
          // Dark mode
          "dark:bg-input/30",
          // Resize - allow vertical resize only
          "resize-y",
          className,
        )}
        {...props}
      />
    );
  }
);

Textarea.displayName = "Textarea";

export { Textarea };
